export const OFFICE_CONSTANT = {
  OFFICE_COUNT: "/office/count",
  OFFICE_DATA: "/office",
  OFFICE_SOFT_DELETE: "/office/softDelete",
  SUPER_DASHBOARD_DATA: "/office",
  CAST: "/cast",
  USER_CHECK: "/user/check",
};
